'use client';

import { useContext, type ReactNode } from 'react';
import { ScreenLayoutContext } from './ScreenLayoutContext';

const NO_OP_CONTEXT = {
  fixedTop: { content: null as ReactNode, title: undefined, className: undefined, height: 0 },
  fixedBottom: { content: null as ReactNode, title: undefined, className: undefined, height: 0 },
  tabBar: { visible: false, height: 0 },
  disableSafeArea: false,
  isPreview: false,
  layoutReady: true,
  setFixedTop: () => {},
  setFixedBottom: () => {},
  clearFixedTop: () => {},
  clearFixedBottom: () => {},
  setTabBarVisible: () => {},
  clearTabBar: () => {},
  registerTabBarOverride: () => {},
  unregisterTabBarOverride: () => {},
  setDisableSafeArea: () => {},
  registerFixedTopRef: () => {},
  registerFixedBottomRef: () => {},
  registerTabBarRef: () => {},
} as const;

export function useScreenLayout() {
  // Fall back to a benign default outside ScreenLayoutProvider — landing
  // anonymous routes use ScreenContent without the full TMA layout chrome.
  return useContext(ScreenLayoutContext) ?? NO_OP_CONTEXT;
}
